/**
 * @generated SignedSource<<31389987a5f80bfb528af213aab6cc1f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "request"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "LandResponse",
    "kind": "LinkedField",
    "name": "landImpulse",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Land",
        "kind": "LinkedField",
        "name": "lands",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PickEx",
            "kind": "LinkedField",
            "name": "pickExs",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "index",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Solve",
        "kind": "LinkedField",
        "name": "solves",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "amount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "serviceFeeAmount",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "graphqlLandImpulseQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "graphqlLandImpulseQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ef0261c610a6b3e0a33bd9862caed1fb",
    "id": null,
    "metadata": {},
    "name": "graphqlLandImpulseQuery",
    "operationKind": "query",
    "text": "query graphqlLandImpulseQuery(\n  $request: LandRequestInput\n) {\n  landImpulse(request: $request) {\n    lands {\n      pickExs {\n        index\n      }\n    }\n    solves {\n      amount\n      serviceFeeAmount\n    }\n  }\n}\n"
  }
};
})();

node.hash = "b8b49b289f3ee28b6bf84fbd7804bd98";

module.exports = node;
